module.exports = __webpack_public_path__ + "img/motor-third-party-damage-icon.f8796444.svg";